function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", {
  id: "suaz-logo-svg_svg__defs4"
}, /*#__PURE__*/React.createElement("style", {
  id: "style2"
}, ".suaz-logo-svg_svg__cls-1{fill:#ffcf2e}.suaz-logo-svg_svg__cls-2{fill:#515351}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "suaz-logo-svg_svg__cls-1",
  d: "M323.52 143.92a2 2 0 01-1.85-1.67l-2.79-31.4h-48.6l-17.06 31.58a2.68 2.68 0 01-2.42 1.49h-27.08a.9.9 0 01-.74-1.49l73.27-127.08a3.19 3.19 0 012.6-1.48h34.69a2 2 0 011.85 1.67l13.73 126.71a1.42 1.42 0 01-1.48 1.67zm-6.49-55.55l-5-55.55-29.68 55.55z",
  id: "suaz-logo-svg_svg__path6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "suaz-logo-svg_svg__cls-1",
  d: "M439.02 127.16a2.16 2.16 0 01-2 1.64H338.2a1.28 1.28 0 01-1.29-1.64l4.61-19.36a6.52 6.52 0 011.47-2.74l86.63-83.42h-61.38a1.38 1.38 0 01-1.29-1.65l4.06-17.34a2.15 2.15 0 012-1.64h93.63a1.28 1.28 0 011.29 1.64l-4.8 20.08a6.52 6.52 0 01-1.47 2.74l-85.71 82.69h65.8a1.28 1.28 0 011.29 1.64z",
  id: "suaz-logo-svg_svg__path8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "suaz-logo-svg_svg__cls-2",
  d: "M87.29 47.8c0 10-9.25 17.44-23.38 17.44-14.51 0-25.8-6.92-24.54-17.14a1 1 0 011-.88h12.44a.87.87 0 01.88.88c0 5.16 4.38 8.08 11.1 8.08 5.65 0 8-2.73 8-5.84 0-8.19-27.86-4-27.86-21.43 0-8 7.6-16.17 23.38-16.17 11.59 0 22.5 5.07 21.91 15.78a1 1 0 01-1 .88H77.4a.87.87 0 01-.88-.88c-.2-4.09-2.83-6.92-9-6.92-5.55 0-7.89 2.93-7.89 5.85 0 8.14 27.66 3.85 27.66 20.35z",
  id: "suaz-logo-svg_svg__path10"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "suaz-logo-svg_svg__cls-2",
  d: "M115.4 62.18a1.85 1.85 0 01-1.07 1.17 34.71 34.71 0 01-9.45 1.65c-8.48 0-15.59-4.28-13-15.68l5.94-25.13h-5.74a.72.72 0 01-.68-.87l2-8.57a1.15 1.15 0 011.07-.88h5.56l2.53-11.69a1.13 1.13 0 011.07-.87h13.24a.69.69 0 01.69.87l-2.92 11.69h11.1a.68.68 0 01.68.88l-2 8.57a1.13 1.13 0 01-1.07.87h-11.1l-5.65 24.74c-1 4.29.78 5.65 4 5.65a19.58 19.58 0 006-.88.59.59 0 01.68.69z",
  id: "suaz-logo-svg_svg__path12"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "suaz-logo-svg_svg__cls-2",
  d: "M152.45 64.03a.74.74 0 01-.69-.88l1-3.41A20 20 0 01139.12 65c-13.44 0-21.62-12.17-17.43-29.9 2.63-11.39 10-22.2 24.06-22.2 7.2 0 12.95 3 15.87 8.76l1.27-6.91a1.13 1.13 0 011.07-.88h13.05a.68.68 0 01.68.88L171.85 39l-5.36 24.15a1.14 1.14 0 01-1.07.88zm-7.7-8.77c6.23.1 10.42-4.67 12.66-13.83 2.63-11.88-.87-18.31-7.59-18.79h-1.76c-5.74.39-9.74 5.16-11.68 14.12-2.93 12.04 1.02 18.6 8.37 18.5z",
  id: "suaz-logo-svg_svg__path14"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "suaz-logo-svg_svg__cls-2",
  d: "M171.73 64.03a.68.68 0 01-.68-.88l5.84-24.25 5.36-24.1a1.13 1.13 0 011.07-.88h12.66a.68.68 0 01.68.88l-2 7.59a25.36 25.36 0 0119-8.86 15.62 15.62 0 012.14.19.9.9 0 01.6 1.08l-2.11 9a1 1 0 01-1.07.78 10.83 10.83 0 00-1.75-.09c-8.87 0-18.51 6.72-20.95 17.24l-4.87 21.42a1.13 1.13 0 01-1.07.88z",
  id: "suaz-logo-svg_svg__path16"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "suaz-logo-svg_svg__cls-2",
  d: "M240.29 62.18a1.8 1.8 0 01-1.07 1.17 34.58 34.58 0 01-9.45 1.65c-8.47 0-15.58-4.28-13-15.68l5.94-25.13h-5.74a.73.73 0 01-.69-.87l2-8.57a1.14 1.14 0 011.07-.88h5.55l2.53-11.69a1.15 1.15 0 011.08-.87h13.24a.68.68 0 01.68.87l-2.92 11.69h11.1a.69.69 0 01.69.88l-1.9 8.57a1.14 1.14 0 01-1.07.87h-11.1l-5.65 24.74c-1 4.29.78 5.65 4 5.65a19.51 19.51 0 005.94-.88.58.58 0 01.68.69z",
  id: "suaz-logo-svg_svg__path18"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "suaz-logo-svg_svg__cls-2",
  d: "M177.15 77.92a.69.69 0 01.68.88l-5.65 23.18-5.65 25.22a1.15 1.15 0 01-1.07.88h-12.37a.73.73 0 01-.68-.88l1.56-5.45c-4.19 4.19-9.74 7.5-16 7.5-11.3 0-17.33-7-14.7-19.48l2.24-10.52 4.69-20.45a1.14 1.14 0 011.07-.88h12.76a.68.68 0 01.68.88l-5.06 20.45-2.34 10.32c-1.27 5.56 1.56 9 6.72 9 4.87 0 11-4.87 13.54-15.59l.78-3.7 4.77-20.48a1.14 1.14 0 011.07-.88z",
  id: "suaz-logo-svg_svg__path20"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "suaz-logo-svg_svg__cls-2",
  d: "M203.25 129.05c-7.11 0-12.67-2.92-15.68-8.37l-5.07 23.12a1.14 1.14 0 01-1.07.88h-13.15a.68.68 0 01-.68-.88l8.57-36 6.43-29a1.14 1.14 0 011.07-.88h12.86a.69.69 0 01.68.88l-1 3.41a20 20 0 0113.64-5.26c13.44 0 21.62 12.17 17.43 29.9-2.61 11.39-10.01 22.2-24.03 22.2zm-3.22-9.74c6.24 0 10.42-4.67 12.57-14.12 2.82-12.08-1-18.5-8.38-18.5-6.23 0-10.52 4.67-12.66 13.83-2.83 12.37 1.17 18.79 8.47 18.79z",
  id: "suaz-logo-svg_svg__path22"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "suaz-logo-svg_svg__cls-1",
  d: "M47.28 158.94l134.51-.52 31.21-.15c0 13-15.33 23.55-34.24 23.55H5.2c0-14.02 21.67-22.88 42.08-22.88z",
  id: "suaz-logo-svg_svg__path24"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M224.66 157.8l167.91-.55 39-.16c0 13.62-19.14 24.67-42.74 24.67H172.14c0-14.68 27.05-23.96 52.52-23.96z",
  id: "suaz-logo-svg_svg__path26",
  fill: "#a3a39f"
});

function SvgSuazLogoSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "suaz-logo-svg_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 475 185",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

export default SvgSuazLogoSvg;